"use server"

import { sdk } from "@lib/config"
import {
  createContactCaptcha,
  verifyContactCaptcha,
} from "@lib/util/contact-captcha"

export type ContactFormState = {
  ok: boolean
  message: string
  captchaQuestion?: string
  captchaToken?: string
}

function freshCaptchaFields() {
  const captcha = createContactCaptcha()
  return {
    captchaQuestion: captcha.question,
    captchaToken: captcha.token,
  }
}

export async function submitContactForm(
  _prev: ContactFormState,
  formData: FormData
): Promise<ContactFormState> {
  const captchaToken = String(formData.get("captcha_token") || "").trim()
  const captchaAnswer = String(formData.get("captcha_answer") || "").trim()

  if (!verifyContactCaptcha(captchaToken, captchaAnswer)) {
    return {
      ok: false,
      message: "คำตอบ CAPTCHA ไม่ถูกต้อง หรือหมดอายุ กรุณาลองใหม่",
      ...freshCaptchaFields(),
    }
  }

  const payload = {
    name: String(formData.get("name") || "").trim(),
    email: String(formData.get("email") || "").trim(),
    phone: String(formData.get("phone") || "").trim(),
    company: String(formData.get("company") || "").trim(),
    subject: String(formData.get("subject") || "").trim(),
    message: String(formData.get("message") || "").trim(),
    website: String(formData.get("website") || "").trim(),
  }

  if (!payload.name || !payload.email || !payload.subject || !payload.message) {
    return {
      ok: false,
      message: "กรุณากรอกชื่อ อีเมล หัวข้อ และข้อความให้ครบ",
      ...freshCaptchaFields(),
    }
  }

  try {
    await sdk.client.fetch<{ success: boolean }>("/store/contact", {
      method: "POST",
      body: payload,
    })

    return {
      ok: true,
      message: "ส่งข้อความเรียบร้อยแล้ว ทีมขายจะติดต่อกลับโดยเร็ว",
      ...freshCaptchaFields(),
    }
  } catch (error) {
    const raw =
      error instanceof Error ? error.message : "Unable to send contact form"

    if (/unavailable|not configured|SMTP|sales@vxwork\.com/i.test(raw)) {
      return {
        ok: false,
        message:
          "ระบบส่งอีเมลยังไม่พร้อมใช้งาน กรุณาติดต่อ sales@vxwork.com โดยตรง",
        ...freshCaptchaFields(),
      }
    }

    return {
      ok: false,
      message:
        "ส่งข้อความไม่สำเร็จ กรุณาลองใหม่ หรืออีเมลหา sales@vxwork.com",
      ...freshCaptchaFields(),
    }
  }
}
